<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="$l('diageo_select_sample') || '选择样品'"
      visible
      width="1200px"
      show-close
      @close="close"
      append-to-body
    >
      <div>
        <FabricColorTable
          :tableHeight="500"
          :url="url"
          :extrasParams="extrasParams"
          @choose-change="(r) => (checkedRows = r)"
        />
      </div>
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('btn_cancel') || '取消' }}
        </el-button>
        <el-badge :value="checkedCount" class="ml-2">
          <el-button
            type="primary"
            size="small"
            @click="confirm()"
            :disabled="!checkedCount"
          >
            {{ $l('btn_confirm') || '确认' }}
          </el-button>
        </el-badge>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import FabricColorTable from './table.vue'
import EditLoading from '@/mixins/edit-loading'

export default {
  props: {
    visible: { type: Boolean, default: false },
    url: {
      type: String,
      default: '/digitalCenter/customer/dev/tracking/choose',
    },
    custCode: {
      type: String,
      default: '',
    },
  },
  mixins: [EditLoading],
  components: { FabricColorTable },
  data() {
    return { checkedRows: null }
  },
  computed: {
    checkedCount() {
      return !this.checkedRows ? 0 : this.checkedRows.length
    },
    extrasParams() {
      return {
        custCode: this.custCode,
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    confirm() {
      if (!this.checkedCount) return
      this.$emit('chooseSample', this.checkedRows)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
